import moment from "moment";
import constants from "@tracking/utils/constants";
import { getPedidos } from "../slices/utils";

const { DATETIME_FORMAT } = constants;

export const detalheOcorrensReducer = (
  state: any,
  action: { payload: any }
) => {
  state.dataEdi.detalheOcorrens = getPedidos(
    action.payload?.lista,
    action.payload?.tipoDocumento
  );
  state.dataEdi.detalheOcorrensFiltersCSV = {
    ...state.dataEdi.detalheOcorrensFiltersCSV,
    tipoDocumento: action.payload?.tipoDocumento,
    tipoCarga: action.payload?.tipoCarga,
    tipoFiltro: action.payload?.tipoFiltro,
    totalItems: action.payload?.totalItens,
    totalPages: action.payload?.totalPaginas,
    valorFiltro: action.payload?.valorFiltro,
    pagina: action.payload?.pagina,
    itensPorPagina: action.payload?.itensPorPagina,
    dataHoraInicial: moment(action.payload?.dataHoraInicial).format(
      DATETIME_FORMAT.API
    ),
    dataHoraFinal: moment(action.payload?.dataHoraFinal).format(
      DATETIME_FORMAT.API
    ),
  };

  state.dataEdi.detalheOcorrensFilters = {
    ...state.dataEdi.detalheOcorrensFilters,
    dataHoraInicial: moment(action.payload?.dataHoraInicial).format(
      DATETIME_FORMAT.API
    ),
    dataHoraFinal: moment(action.payload?.dataHoraFinal).format(
      DATETIME_FORMAT.API
    ),
    tipoDocumento: action.payload?.tipoDocumento,
    tipoCarga: action.payload?.tipoCarga,
    tipoFiltro: action.payload?.tipoFiltro,
    totalItems: action.payload?.totalItens,
    totalPages: action.payload?.totalPaginas,
    valorFiltro: action.payload?.valorFiltro,
    pagina: action.payload?.pagina,
    itensPorPagina: action.payload?.itensPorPagina,
  };
};
